require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-covid-19-marginalizedgroups.json") })
        }
      }, "path---en-us-update-covid-19-marginalizedgroups");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-covid-19-marginalizedgroups!./.cache/json/en-us-update-covid-19-marginalizedgroups.json
// module id = 650
// module chunks = 231608221292675